if (!customElements.get('cart-reservation')) {
  customElements.define(
    'cart-reservation',
    class CartReservation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.timeSlot = this.querySelector('#cart-reservation-time');
        this.time = parseInt(this.dataset.time);
        this.counter = 0;

        this.intervalId = setInterval(() => {
          this.counter += 1;
          if (this.counter >= this.time) {
            clearInterval(this.intervalId)
          }

          this.updateTime();
        }, 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
      }

      updateTime() {
        const diff = this.time - this.counter;
        this.timeSlot.textContent = Math.floor(diff / 60).toString().padStart(2, '0') + ':' + (diff % 60).toString().padStart(2, '0');
      }
    }
  );
}
